import { render } from "./UserSettings.vue?vue&type=template&id=5ff879a1"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"
script.render = render

export default script